import { Link } from "react-router-dom";
import "./index.less";

const BreadcrumbC = () => {
  return (
    <article className="breadcrumb-wrapper shop-pc">
      <div className="max-width">
        <div className="breadcrumb">
          <div>
            <Link to="/service/center">服务中心</Link>
            <span className="separator">{">"}</span>
          </div>
          <span>快速下单</span>
        </div>
      </div>
    </article>
  );
};

export default BreadcrumbC;
